import { ref } from 'vue';
import { app }  from '../firebase.js';
import { getAuth } from 'firebase/auth';

const baseURL = 'https://api.animauxdelasecondechance.com'; // Base URL de l'API
const auth = getAuth(app);

// Nouvelle fonction pour vérifier les droit d'accès de l'admin
async function verifierDroitsAdmin() {
  try {
    const user = auth.currentUser;
    if (!user) return false;
    // Toujours récupérer un token frais pour vérifier les droits
    const tokenResult = await user.getIdTokenResult(true);
    return tokenResult.claims.admin === true;
  } catch (error) {
    console.error("Erreur lors de la vérification des droits admin:", error);
    return false;
  }
}

// Fonction pour afficher la liste des chats
  function useListeChats() {
    const listeChats = ref([]);
    const message = ref('');

    const chargerlisteChats = async () => {
    try {
      const response = await fetch(`${baseURL}/api/liste_chats/`);
      const data = await response.json();
      console.log('API Response:', data);
      if (
        data.status === 'success' && 
        data.listeChats && 
        Array.isArray(data.listeChats.data)
      ) {
        listeChats.value = data.listeChats.data.map(chat => {
          if (chat.image && chat.image.startsWith('../../')) {
            chat.image = `${baseURL}${chat.image.slice(5)}`;
          }
          return chat;
        });
        message.value = "Bonjour, voici la liste des chats";
      } else {
        message.value = "Impossible de charger la liste des chats";
        listeChats.value = [];
      }
    } catch (error) {
      console.error("Erreur lors du chargement des liste des chats:", error);
      message.value = "Impossible de charger la liste des chats";
      listeChats.value = [];
    }
  };

  // Note : passer le token en paramètre
  const ajouter = async (chat) => {
    console.log("Valeur du chat à ajouter :", chat);
    try {
      const estAdmin = await verifierDroitsAdmin();
      if (!estAdmin) {
        throw new Error("Droits administrateur requis pour ajouter un chat");
      }

      const user = auth.currentUser;
      if (!user) throw new Error("Utilisateur non connecté");
      const token = await user.getIdToken(true);

      const formData = new FormData();
      Object.keys(chat).forEach(key => {
        if (chat[key] !== null && chat[key] !== undefined) {
          formData.append(key, chat[key]);
        }
      });

      const response = await fetch(
        "https://api.animauxdelasecondechance.com/api/liste_chats/index.php",
        {
          method: "POST",
          headers: {
            'Authorization': `Bearer ${token}`,
          },
          body: formData,
        }
      );
      const data = await response.json();
      console.log("Réponse API:", data);
      if (data.status === 'success') {
        message.value = 'Le chat a été ajouté avec succès';
        await chargerlisteChats();
      } else {
        message.value = "Impossible d'ajouter le chat";
      }
    } catch (error) {
      console.error("Erreur lors de l'ajout du chat:", error);
      message.value = "Impossible d'ajouter le chat";
    }
  };

  const mettreAJour = async (chat) => {
    try {
      const user = auth.currentUser;
      if (!user) throw new Error("Utilisateur non connecté");
      const token = await user.getIdToken(true);
      console.log("Token envoyé:", token);
      if (!token) { 
        throw new Error("Token Firebase manquant pour la mise à jour");
      }
      const response = await fetch(`${baseURL}/api/liste_chats/?id=${chat.id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(chat)
      });
      const data = await response.json();
      console.log("Réponse API:", data);
      if (data.status === 'success') {
        message.value = "Le chat a été mis à jour avec succès";
        await chargerlisteChats();
      } else {
        message.value = "Impossible de mettre à jour le chat";
      }
    } catch (error) {
      console.error("Erreur lors de la mise à jour du chat:", error);
      message.value = "Impossible de mettre à jour le chat";
    }
  };

  const mettreAJourPartiellement = async (id, modifications) => {
    try {
      const user = auth.currentUser;
      if (!user) throw new Error("Utilisateur non connecté");
      console.log("Utilisateur connecté:", user.uid);
      console.log("Courriel de l'utilisateur:", user.email);

      const token = await user.getIdToken(true);
      console.log("Token envoyé:", token);
      if (!token) {
        throw new Error("Token Firebase manquant pour la mise à jour partielle");
      }
      const response = await fetch(`${baseURL}/api/liste_chats/?id=${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(modifications)
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error ${response.status} ${errorText}`);
      }

      const data = await response.json();
      console.log("Réponse API mise à jour partielle:", data);

      if (data.status === 'success' && data.listeChats && data.listeChats.data) {
        return {
          success: true,
          message: "Modification réussie",
          chat: data.listeChats.data.find(c => c.id === id) || null,
        };
      } else {
        return {
          success: false,
          message: data.message || "Erreur lors de la mise à jour",
        };
      }
    } catch (error) {
      console.error("Erreur lors de la mise à jour partielle du chat:", error);
      return {
        success: false,
        message: error.message || "Erreur inconnue lors de la mise à jour.",
      };
    }
  };

  const supprimer = async (id) => {
    try {
      const user = auth.currentUser;
      if (!user) throw new Error("Utilisateur non connecté");
      const token = await user.getIdToken(true);
      console.log("Token envoyé:", token);
      if (!token) {
        throw new Error("Token Firebase manquant pour la suppression");
      }
      const response = await fetch(`${baseURL}/api/liste_chats/?id=${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      console.log("Réponse API:", data);
      if (data.status === 'success') {
        message.value = "Le chat a été supprimé avec succès";
        await chargerlisteChats();
      } else {
        message.value = 'Impossible de supprimer le chat';
      }
    } catch (error) {
      console.error("Erreur lors de la suppression du chat:", error);
      message.value = "Impossible de supprimer le chat";
    }
  };

    return {
      listeChats,
      message,
      chargerlisteChats,
      ajouter,
      mettreAJour,
      mettreAJourPartiellement,
      supprimer
    };
  }

  // Fonction pour gérer les chatons de 0 à 5 mois
  function useListeChatons0_5Mois() {
    const listeChatons0_5Mois = ref([]);
    const message = ref('');
    const chargerListeChatons0_5Mois = async () => {
      try {
        const response = await fetch(`${baseURL}/api/chatons_0_5_mois/`);
        const data = await response.json();
        console.log('API Response:', data);
        if (Array.isArray(data)) {
          listeChatons0_5Mois.value = data.map(chat => {
            if (chat.image && chat.image.startsWith('../../')) {
              chat.image = `${baseURL}${chat.image.slice(5)}`;
            }
            return chat;
          });
          message.value = "Bonjour, voici la liste des chatons de 0 à 5 mois";
        } else {
          message.value = "Impossible de charger la liste des chatons de 0 à 5 mois";
        }
      } catch (error) {
        console.error("Erreur lors du chargement de la liste des chatons de 0 à 5 mois:", error);
        message.value = "Impossible de charger la liste des chatons de 0 à 5 mois";
        listeChatons0_5Mois.value = [];
      }
    }
    return {
      listeChatons0_5Mois,
      message,
      chargerListeChatons0_5Mois
    };
  }

  // Fonction pour gérer les chatons de 6 à 12 mois
  function useListeChatons6_12Mois() {
    const listeChatons6_12Mois = ref([]);
    const message = ref('');
    const chargerListeChatons6_12Mois = async () => {
      try {
        const response = await fetch(`${baseURL}/api/chatons_6_12_mois/`);
        const data = await response.json();
        console.log('API Response:', data);
        if (Array.isArray(data)) {
          listeChatons6_12Mois.value = data.map(chat => {
            if (chat.image && chat.image.startsWith('../../')) {
              chat.image = `${baseURL}${chat.image.slice(5)}`;
            }
            return chat;
          });
          message.value = "Bonjour, voici la liste des chatons de 6 à 12 mois";
        } else {
          message.value = "Impossible de charger la liste des chatons de 6 à 12 mois";
        }
      } catch (error) {
        console.error("Erreur lors du chargement de la liste des chatons de 6 à 12 mois:", error);
        message.value = "Impossible de charger la liste des chatons de 6 à 12 mois";
        listeChatons6_12Mois.value = [];
      }
    }
    return {
      listeChatons6_12Mois,
      message,
      chargerListeChatons6_12Mois
    };
  }

  // Fonction pour gérer les chats adoptés
  function useListeChatsAdoptes() {
    const listeChatsAdoptes = ref([]);
    const message = ref('');

    const chargerListeChatsAdoptes = async () => {
      try {
        const response = await fetch(`${baseURL}/api/chats_adoptes_recents/`);
        const data = await response.json();
        console.log('API Response:', data);
        if (Array.isArray(data)) {
          listeChatsAdoptes.value = data.map(chat => {
            if (chat.image && chat.image.startsWith('../../')) {
              chat.image = `${baseURL}${chat.image.slice(5)}`;
            }
            return chat;
          });
          message.value = "Bonjour, voici la liste des chats adoptés";
        } else {
          message.value = "Impossible de charger la liste des chats adoptés";
        }
      } catch (error) {
        console.error("Erreur lors du chargement de la liste des chats adoptés:", error);
        message.value = "Impossible de charger la liste des chats adoptés";
      }
    };

    return {
      listeChatsAdoptes,
      message,
      chargerListeChatsAdoptes
    };
  }

  // Fonction pour afficher la liste des chats craintifs
  function useListeChatsCraintifs() {
    const listeChatsCraintifs = ref([]);
    const message = ref('');

    const chargerListeChatsCraintifs = async () => {
      try {
        const response = await fetch(`${baseURL}/api/chats_craintifs/`);
        const data = await response.json();
        console.log('API Response:', data);
        if (Array.isArray(data)) {
          listeChatsCraintifs.value = data.map(chat => {
            if (chat.image && chat.image.startsWith('../../')) {
              chat.image = `${baseURL}${chat.image.slice(5)}`;
            }
            return chat;
          });
          message.value = "Bonjour, voici la liste des chats craintifs";
        } else {
          message.value = "Impossible de charger la liste des chats craintifs";
        }
      } catch (error) {
        console.error("Erreur lors du chargement de la liste des chats craintifs:", error);
        message.value = "Impossible de charger la liste des chats craintifs";
      }
    };

    return {
      listeChatsCraintifs,
      message,
      chargerListeChatsCraintifs
    };
  }

  // Fonction pour afficher la liste des chats femelles

  function useListeChatsFemelles() {
    const listeChatsFemelles = ref([]);
    const message = ref('');

    const chargerListeChatsFemelles = async () => {
    try {
      const response = await fetch(`${baseURL}/api/chats_femelles/`);
      const data = await response.json();
      console.log('API Response:', data);
      if (Array.isArray(data)) {
        listeChatsFemelles.value = data.map(chat => {
          if (chat.image && chat.image.startsWith('../../')) {
            chat.image = `${baseURL}${chat.image.slice(5)}`;
          }
          return chat;
        });
        message.value = "Bonjour, voici la liste des chats femelles";
        } else if (data && typeof data === 'object') {
        // <-- Ajoute ce bloc pour gérer le cas objet
        listeChatsFemelles.value = Object.values(data).map(chat => {
          if (chat.image && chat.image.startsWith('../../')) {
            chat.image = `${baseURL}${chat.image.slice(5)}`;
          }
          return chat;
        });
        message.value = "Bonjour, voici la liste des chats femelles";
      } else {
        message.value = "Impossible de charger la liste des chats femelles";
        listeChatsFemelles.value = [];
      }
    } catch (error) {
      console.error("Erreur lors du chargement de la liste des chats femelles:", error);
      message.value = "Impossible de charger la liste des chats femelles";
      listeChatsFemelles.value = [];
    }
  };

  return {
    listeChatsFemelles,
    message,
    chargerListeChatsFemelles
  };
}

  // Fonction pour afficher la liste des chats mâles

  function useListeChatsMales() {
    const listeChatsMales = ref([]);
    const message = ref('');

    const chargerListeChatsMales = async () => {
      try {
        const response = await fetch(`${baseURL}/api/chats_males/`);
        const data = await response.json();
        console.log('API Response:', data);
        if (Array.isArray(data)) {
          listeChatsMales.value = data.map(chat => {
            if (chat.image && chat.image.startsWith('../../')) {
              chat.image = `${baseURL}${chat.image.slice(5)}`;
            }
            return chat;
          });
          message.value = "Bonjour, voici la liste des chats mâles";
        } else if (data && typeof data === 'object') {
          // <-- Ajoute ce bloc pour gérer le cas objet
          listeChatsMales.value = Object.values(data).map(chat => {
            if (chat.image && chat.image.startsWith('../../')) {
              chat.image = `${baseURL}${chat.image.slice(5)}`;
            }
            return chat;
          });
          message.value = "Bonjour, voici la liste des chats mâles";
        } else {
          message.value = "Impossible de charger la liste des chats mâles";
        }
      } catch (error) {
        console.error("Erreur lors du chargement de la liste des chats mâles;", error);
        message.value = "Impossible de charger la liste des chats mâles";
      }
    };
    return {
      listeChatsMales,
      message,
      chargerListeChatsMales
    };
  }


export {
  verifierDroitsAdmin,
  useListeChats,
  useListeChatsAdoptes,
  useListeChatsCraintifs,
  useListeChatsFemelles,
  useListeChatsMales,
  useListeChatons0_5Mois,
  useListeChatons6_12Mois
}